// removed by extract-text-webpack-plugin
module.exports = {"ContactCard":"_3exHVX5i","LinkContainer":"_1Jy9EHwM","ContactCardRow":"_1yv7lipR","ContactCardRowPersistent":"_2XGz1m0T","ContactIcon":"_2iiAjnnb","ContactIconPersistent":"_1Eiz1VoY","ContactRowText":"_3H4Zf6Hm","ContactRowTextPersistent":"_3gfd96uE"};


//////////////////
// WEBPACK FOOTER
// ./src/components/cards/contact/contact-card-component.styles.scss
// module id = 244
// module chunks = 0